import { tmmInstance } from 'libraries/axios';

const filterActiveMarkets = (events) => {
  for (const ev of events) {
    if (Array.isArray(ev?.markets)) {
      ev.markets = ev.markets.filter((m) => m?.marketStatus === 6);
    }
  }
  return events;
};

export const fetchOutrightsAllEventsReq = () => {
  return new Promise((resolve, reject) =>
    tmmInstance
      .post('/BetEvent/Outrights/OutrightsAllEvents_F', {
        includeMarketsWithNoEnabledOutcomes: false
      })
      .then((response) => {
        resolve(filterActiveMarkets(response.data?.data?.events ?? []));
      })
      .catch((error) => {
        reject(error);
      })
  );
};

export const fetchOutrightsByParentTournamentReq = (sportEventId) => {
  return new Promise((resolve, reject) =>
    tmmInstance
      .post('/BetEvent/Outrights/GetMarketsByParentTournament', {
        sportEventId,
        includeMarketsWithNoBettableOutcomes: false
      })
      .then((response) => {
        resolve(filterActiveMarkets(response.data?.data?.events ?? []));
      })
      .catch((error) => {
        reject(error);
      })
  );
};

export const fetchOutrightsMarketCountReq = () => {
  return new Promise((resolve, reject) =>
    tmmInstance
      .post('/BetEvent/Outrights/GetOutrightsMarketCount', {
        includeMarketsWithNoEnabledOutcomes: false
      })
      .then((response) => {
        resolve(response.data?.data?.count ?? 0);
      })
      .catch((error) => {
        reject(error);
      })
  );
};
